import { Accept } from "react-dropzone";

import FlexWrapper, { FlexDirection } from "@gx/dls/containers/FlexWrapper";

import type { FileUploadProgress } from "@/pages/sources/components/create/sources/types";
import DropzoneWidgetDropzone from "@/pages/sources/components/dropzone/DropzoneWidgetDropzone";
import DropzoneWidgetExplorer from "@/pages/sources/components/dropzone/DropzoneWidgetExplorer";

export interface DropzoneWidgetProps {
  files: File[];
  onFilesChange: (files: File[]) => void;
  onDrop: (acceptedFiles: File[]) => void;
  accept?: Accept;
  fileProgressMap?: Map<string, FileUploadProgress>;
  isDisabled?: boolean;
}

const DropzoneWidget = ({
  files,
  onFilesChange,
  onDrop,
  accept,
  fileProgressMap,
  isDisabled = false,
}: DropzoneWidgetProps) => {
  return (
    <FlexWrapper direction={FlexDirection.COLUMN} gap={8} fillWidth>
      <DropzoneWidgetDropzone onDrop={onDrop} accept={accept} isDisabled={isDisabled} />
      <DropzoneWidgetExplorer
        files={files}
        onFilesChange={onFilesChange}
        fileProgressMap={fileProgressMap}
        isDisabled={isDisabled}
      />
    </FlexWrapper>
  );
};

export default DropzoneWidget;
